export default __webpack_public_path__ + "static/media/slider-nexx-2.e6d20ec3.jpg";